import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEditFieldStaff, addFieldStaffView } from "../../actions/user";
import { UserModal } from "../../components/Modal";
import UserSelect from "../../components/SelectBox/UserSelect";
import { TextInput } from "../../components/TextInput";
import useForm from "../../hooks/useForm";
import useToast from "../../hooks/useToast";
import useUserDetail from "../../hooks/useUserDetail";
import { RegxConstant } from "../../utils/regxConstant";

const validationSchema = {
  firstName: { required: true },
  lastName: { required: true },
  stateId: { required: true },
  cityId: { required: true },
  street1: { required: true },
  mobileNo: {
    required: true,
    validator: {
      regEx: RegxConstant.MOBILE_NO,
      error: "Please enter 10 digit mobile number.",
    },
  },
};

export default ({ show, toggle, selectedUser }) => {
  const {
    state: userDetail,
    errors,
    handleChange,
    setState,
    handleSubmit,
  } = useForm({}, validationSchema, handleSave);
  const [cities, setCities] = useState([]);
  const [distributorList, setDistributorList] = useState([]);
  const { isManager } = useUserDetail();
  const { showError } = useToast();

  useEffect(() => {
    setState(selectedUser ? selectedUser : {});
  }, [selectedUser]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(addFieldStaffView());
  }, []);

  function handleSave(userDetail) {
    const { coordinatorId, distributorId } = userDetail;
    if (isManager && !coordinatorId && !distributorId) {
      showError("Please select RSM_ASM or Distributor");
      return;
    }
    dispatch(
      addEditFieldStaff(userDetail, () => {
        toggle();
      })
    );
  }

  const {
    states,
    stateCities,
    coordinatorList,
    distributorList: initDistributorList,
  } = useSelector((state) => state.user);

  const {
    email,
    firstName,
    lastName,
    stateId,
    cityId,
    street1,
    street2,
    mobileNo,
    coordinatorId,
    distributorId,
  } = userDetail;

  useEffect(() => {
    if (stateId && stateCities) {
      setCities(
        stateCities
          .filter((c) => c.stateId == stateId)
          .map((c) => ({
            text: c.city,
            value: c.cityId,
          }))
      );
    } else setCities([]);
  }, [stateId, stateCities]);

  useEffect(() => {
    if (initDistributorList) {
      let distributorList = initDistributorList;
      if (coordinatorId) {
        distributorList = distributorList.filter(
          (c) => c.coordinatorId == coordinatorId
        );
      }
      setDistributorList(
        distributorList.map((c) => ({
          value: c.value,
          text: `${c.text}-${c.email}`,
        }))
      );
    }
  }, [initDistributorList, coordinatorId]);

  return (
    <UserModal
      btnText="Save"
      show={show}
      heading="Add Field Staff"
      onClose={toggle}
      handleClick={handleSubmit}
    >
      <form onSubmit={handleSubmit} method="post">
        <div className="row">
          <div className="col-6">
            <TextInput
              name="firstName"
              id="firstName"
              value={firstName}
              asterix
              placeholder="First Name"
              onChange={handleChange}
              errors={errors}
              formatText
            />
          </div>
          <div className="col-6">
            <TextInput
              name="lastName"
              id="lastName"
              value={lastName}
              asterix
              placeholder="Last Name"
              onChange={handleChange}
              errors={errors}
              formatText
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <TextInput
              name="email"
              id="email"
              value={email}
              asterix
              placeholder="Email Id"
              onChange={handleChange}
              errors={errors}
            />
          </div>
          <div className="col-6">
            <TextInput
              name="mobileNo"
              id="mobileNo"
              value={mobileNo}
              asterix
              placeholder="Mobile No"
              onChange={handleChange}
              errors={errors}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <UserSelect
              name="stateId"
              value={stateId}
              options={states}
              onChange={handleChange}
              placeholder="Select State"
              errors={errors}
            />
          </div>
          <div className="col-6">
            <UserSelect
              name="cityId"
              value={cityId}
              options={cities}
              placeholder="Select City"
              onChange={handleChange}
              errors={errors}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <TextInput
              name="street1"
              id="street1"
              value={street1}
              asterix
              placeholder="Street 1"
              onChange={handleChange}
              errors={errors}
              formatText
            />
          </div>
          <div className="col-6">
            <TextInput
              name="street2"
              id="street2"
              value={street2}
              asterix
              placeholder="Street 2"
              onChange={handleChange}
              errors={errors}
              formatText
            />
          </div>
        </div>
        {isManager && (
          <div className="row">
            <div className="col-6">
              <UserSelect
                name="coordinatorId"
                value={coordinatorId}
                options={coordinatorList}
                placeholder="Select RSM_ASM"
                onChange={handleChange}
                errors={errors}
              />
            </div>
            <div className="col-6">
              <UserSelect
                name="distributorId"
                value={distributorId}
                options={distributorList}
                placeholder="Select Distributor"
                onChange={handleChange}
                errors={errors}
              />
            </div>
          </div>
        )}
      </form>
    </UserModal>
  );
};
